class Table extends React.Component{
	render(){
		return (
			<ReactBootstrap.Table
				{...this.props}
			/>
		)
	}
}